<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="期号">
								<a-input v-model="queryParams.issue" placeholder="期号" />
							</a-form-item>
						</a-col>
                        <a-col :span="4">
                            <a-form-item label="采集">
                                <a-select v-model="queryParams.isCollect" placeholder="全部" allowClear>
                                    <a-select-option value="Y">已采集</a-select-option>
                                    <a-select-option value="N">未采集</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
						<a-col :span="4">
							<a-form-item label="结算">
								<a-select v-model="queryParams.isSettle" placeholder="全部" allowClear>
									<a-select-option value="Y">已结算</a-select-option>
									<a-select-option value="N">未结算</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
                        <template v-if="advanced">
                            <a-col :span="6">
                                <a-form-item label="时间">
                                    <a-range-picker @change="onCreateTime" />
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
                                  :style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="getTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="() => this.queryParams={}">重置</a-button>
								<a @click="()=>{advanced = !advanced;}" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
                        </a-col>
					</a-row>
				</a-form>
			</div>

			<a-table
				:rowKey="record => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<template slot="issue" slot-scope="record">
					<p style="margin:0">{{ record.issue }}</p>
					<span>{{ record.unveilTime }}</span>
				</template>

                <template slot="source" slot-scope="record">
                    <p v-if="record.content != ''" style="margin:0">
                        {{ record.content }}
                    </p>
                    <span v-else>-</span>
                </template>

                <template slot="treated" slot-scope="record">
                    <span v-if="record.treatedContent != ''" style="font-weight:bold; color:#333;">
                        {{ record.treatedContent }}
                    </span>
                    <span v-else>-</span>
                </template>

                <template slot="da" slot-scope="record">
                    <span v-if="record.da == 'Y'" style="color: #e50012">大</span>
                </template>

                <template slot="xiao" slot-scope="record">
                    <span v-if="record.xiao == 'Y'" style="color: #2a64f6">小</span>
                </template>

                <template slot="dan" slot-scope="record">
                    <span v-if="record.dan == 'Y'" style="color: #fa7513">单</span>
                </template>

                <template slot="shuang" slot-scope="record">
                    <span v-if="record.shuang == 'Y'" style="color: #96cb3b">双</span>
                </template>

                <template slot="dadan" slot-scope="record">
                    <span v-if="record.dadan == 'Y'" style="color: #96cb3b">大单</span>
                </template>

                <template slot="dashuang" slot-scope="record">
                    <span v-if="record.dashuang == 'Y'" style="color: #ff9601">大双</span>
                </template>

                <template slot="xiaodan" slot-scope="record">
                    <span v-if="record.xiaodan == 'Y'" style="color: #5a88fe">小单</span>
                </template>

                <template slot="xiaoshuang" slot-scope="record">
                    <span v-if="record.xiaoshuang == 'Y'" style="color: #5a88fe">小双</span>
                </template>

				<span slot="collect" slot-scope="record">
					<div>{{ record.collectStatusText }}</div>
					<div v-if="record.collectTimeText" class="cell-sub">{{ record.collectTimeText }}</div>
				</span>

				<span slot="settle" slot-scope="record">
					<div>{{ record.settleStatusText }}</div>
					<div v-if="record.settleTimeText" class="cell-sub">{{ record.settleTimeText }}</div>
				</span>
			</a-table>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					@change="pageChange"
					:hideOnSinglePage="true"
					show-less-items
				/>
			</div>
		</a-card>
	</div>
</template>

<script>
import { lottoList } from '@/api/op/lotto';

const tableColumns = [
    { title: '#', dataIndex: 'id' },
    { title: '期号', dataIndex: 'issue' },
    { title: '数据源', scopedSlots: { customRender: 'source' }, width: 240 },
    { title: '开奖', scopedSlots: { customRender: 'treated' } },
    { title: '大', scopedSlots: { customRender: 'da' } },
    { title: '小', scopedSlots: { customRender: 'xiao' } },
    { title: '单', scopedSlots: { customRender: 'dan' } },
    { title: '双', scopedSlots: { customRender: 'shuang' } },
    { title: '大单', scopedSlots: { customRender: 'dadan' } },
    { title: '大双', scopedSlots: { customRender: 'dashuang' } },
    { title: '小单', scopedSlots: { customRender: 'xiaodan' } },
    { title: '小双', scopedSlots: { customRender: 'xiaoshuang' } },
    { title: '采集', scopedSlots: { customRender: 'collect' } },
    { title: '结算', scopedSlots: { customRender: 'settle' } },
    { title: '创建时间', dataIndex: 'created' }
];

export default {
	data() {
		return {
            advanced: false,
			queryParams: {},
            tableColumns,
			tableLoading: false,
			tableData: [],
			totalRow: 0,
			pageSize: 20,
			pageIndex: 1,
		};
	},
	computed: {

	},
	created() {
		this.getTableData();
	},
	methods: {
		getTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;

			return lottoList(this.queryParams).then((res) => {
				this.tableData = res.data.recordList || [];
				this.totalRow = res.data.totalRow || 0;
			}).finally(() => {
				this.tableLoading = false;
			});
		},
		pageChange(current) {
			this.pageIndex = current;
			this.getTableData();
		},
	},
};
</script>

<style scoped>
.cell-sub {
	font-size: 12px;
	color: #acacac;
	margin-top: 4px;
}

.attr-hit {
	font-weight: 600;
}
</style>
